import type { RealtimeInvalidationStrategy } from './types';

/**
 * Singleton registry of per-module invalidation strategies.
 * Modules self-register via side-effect imports.
 */
class NotificationStrategyRegistry {
  private strategies = new Map<string, RealtimeInvalidationStrategy>();

  register(strategy: RealtimeInvalidationStrategy): void {
    this.strategies.set(strategy.module, strategy);
  }

  get(module: string): RealtimeInvalidationStrategy | undefined {
    return this.strategies.get(module);
  }
}

export const notificationStrategyRegistry = new NotificationStrategyRegistry();
